import React from 'react';
import { Helmet } from 'react-helmet-async';

function Cookies() {
  return (
    <div className="page-wrapper">
      <Helmet>
        <title>Cookie Policy | Clariti AI</title>
        <meta
          name="description"
          content="Read the Clariti AI cookie policy to understand which cookies we use and how to manage cookie preferences."
        />
        <link rel="canonical" href="https://www.clariti.ai/cookies" />
        <meta property="og:title" content="Cookie Policy | Clariti AI" />
        <meta
          property="og:description"
          content="Understand Clariti AI cookie usage, third-party cookies, and browser cookie controls."
        />
        <meta property="og:type" content="article" />
        <meta property="og:url" content="https://www.clariti.ai/cookies" />
        <meta name="twitter:title" content="Cookie Policy | Clariti AI" />
        <meta
          name="twitter:description"
          content="Learn how cookies are used on clariti.ai and how to manage them."
        />
      </Helmet>
      {/* Hero */}
      <section className="about-hero">
        <div className="container">
          <h1>Cookie Policy</h1>
          <p>Cookie Policy for Clariti AI Limited</p>
        </div>
      </section>

      {/* Cookie Policy Content */}
      <section className="section">
        <div className="container">
          <div className="privacy-content" style={{ maxWidth: '900px', margin: '0 auto' }}>
            <h2>What Are Cookies</h2>
            <p>
              As is common practice with almost all professional websites this site uses cookies, which are tiny files that are downloaded to your computer, to improve your experience.
            </p>
            <p>
              This page describes what information they gather, how we use it and why we sometimes need to store these cookies.
            </p>
            <p>
              We will also share how you can prevent these cookies from being stored however this may downgrade or 'break' certain elements of the sites functionality.
            </p>
            <p>
              For more general information on cookies see the Wikipedia article on <a href="https://en.wikipedia.org/wiki/HTTP_cookie" target="_blank" rel="noopener noreferrer">https://en.wikipedia.org/wiki/HTTP_cookie</a>.
            </p>

            <h2>How We Use Cookies</h2>
            <p>
              We use cookies for a variety of reasons detailed below.
            </p>
            <p>
              Unfortunately in most cases there are no industry standard options for disabling cookies without completely disabling the functionality and features they add to this site.
            </p>
            <p>
              It is recommended that you leave on all cookies if you are not sure whether you need them or not in case they are used to provide a service that you use.
            </p>

            <h2>Disabling Cookies</h2>
            <p>
              You can prevent the setting of cookies by adjusting the settings on your browser (see your browser Help for how to do this). Be aware that disabling cookies will affect the functionality of this and many other websites that you visit. Disabling cookies will usually result in also disabling certain functionality and features of the this site. Therefore it is recommended that you do not disable cookies.
            </p>

            <h2>The Cookies We Set</h2>
            <p>
              In order to provide you with a great experience on this site we provide the functionality to set your preferences for how this site runs when you use it. In order to remember your preferences we need to set cookies so that this information can be called whenever you interact with a page is affected by your preferences.
            </p>

            <h2>Third Party Cookies</h2>
            <p>
              In some special cases we also use cookies provided by trusted third parties. The following section details which third party cookies you might encounter through this site.
            </p>
            <p>
              Third party analytics are used to track and measure usage of this site so that we can continue to produce engaging content. These cookies may track things such as how long you spend on the site or pages you visit which helps us to understand how we can improve the site for you.
            </p>

            <h2>More Information</h2>
            <p>
              Hopefully that has clarified things for you and as was previously mentioned if there is something that you aren't sure whether you need or not it's usually safer to leave cookies enabled in case it does interact with one of the features you use on our site.
            </p>
            <p>
              If you are still looking for more information then you can contact us by email on <a href="mailto:info@clariti.ai">info@clariti.ai</a>.
            </p>
          </div>
        </div>
      </section>
    </div>
  );
}

export default Cookies;

